import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { FramesService } from '@app/core/services';
import { MORPHIS_TARGET_ID } from '../../../../../../../common/integrations';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-frames',
  standalone: true,
  imports: [LoginComponent],
  templateUrl: './frames.component.html',
})
export class FramesComponent implements AfterViewInit {
  constructor(
    private readonly elementRef: ElementRef,
    private readonly framesService: FramesService,
  ) {}

  id = MORPHIS_TARGET_ID;
  ngAfterViewInit(): void {
    this.framesService.bootstrap(this.elementRef);
  }
}
